export default __webpack_public_path__ + "static/media/search-icon-white.6d46509a.svg";